<template>
  <v-main class="color_fondo">
    <div>
      <slot />
    </div>
  </v-main>
</template>

<script>
// import Header from '@/layouts/header_administrativo.vue';
// bimport MenuLateral from '@/layouts/menu_lateral.vue';
//   name: 'Login',
export default {
  name: "login",

  data() {
    return {};
  },

  methods: {},

  components: {},

  /*
     data: () => ({
          mini: true,
          name:'LayoutAdministrativo',
          primaryDrawer: {
          model: null
      },
      }),
    */
  /*
    methods: {
        ...mapActions([
        'logout'
        ])
    }
    */
};
</script>

<style scoped>
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes rotate {
  from {
    -webkit-transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes slide {
  from {
    background-position: 0 0;
  }

  to {
    background-position: -400px 0;
  }
}

@keyframes animatedBackground {
  from {
    background-position: 0 0;
  }

  to {
    background-position: 100% 0;
  }
}

@keyframes anim {
  from {
    transform: scale(1) translateX(0);
  }

  to {
    transform: scale(1.5) translateX(-50%);
  }
}

.color_fondo {
  background: url("../../public/imagenes/CIRCULO-OPACIDAD.svg") repeat 0 0;
  background-color: #01579b;
  background-size: 80%;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  scroll-behavior: smooth;

  /* transform: rotate(-10deg);

  animation: animatedBackground 10s linear infinite alternate;

  -webkit-animation: slide 20s linear infinite;

  -webkit-animation: 3s rotate linear infinite;
  animation: 3s rotate linear infinite;
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%; */
}
</style>
